/*
  Polja osebnih podatkov tečajnika.

  Ista definicija se uporabi ob prvem vpisu (Onboarding) in pozneje, ko
  tečajnik svoje podatke ureja. Prej urejanje po registraciji sploh ni bilo
  mogoče — tipkarske napake in spremenjena telefonska so ostale za vedno.
*/

import { t } from '../i18n/index.js';

/* Oznake, namigi in nadomestna besedila so slovenski ključi — prevedejo se
   ob izrisu s t(f.label). */
export const FIELDS = [
  {
    key: 'ime',
    label: 'Ime in priimek',
    placeholder: 'npr. Janez Novak',
    required: true,
    autoComplete: 'name',
  },
  { key: 'datum_rojstva', label: 'Datum rojstva', type: 'date', required: true, autoComplete: 'bday' },
  { key: 'kraj_rojstva', label: 'Kraj rojstva', placeholder: 'npr. Ljubljana', required: true },
  {
    key: 'naslov',
    label: 'Naslov stalnega prebivališča',
    placeholder: 'npr. Dunajska cesta 5',
    required: true,
    autoComplete: 'street-address',
  },
  {
    key: 'posta',
    label: 'Pošta',
    placeholder: 'npr. 1000 Ljubljana',
    required: true,
    autoComplete: 'postal-code',
  },
  {
    key: 'telefon',
    label: 'Telefonska številka',
    placeholder: 'npr. 040 123 456',
    required: true,
    type: 'tel',
    autoComplete: 'tel',
  },
  { key: 'datum_tecaja', label: 'Datum pričetka tečaja', type: 'date' },
  { key: 'visina_cm', label: 'Višina (cm)', type: 'number', placeholder: 'npr. 178' },
  { key: 'teza_kg', label: 'Teža (kg)', type: 'number', placeholder: 'npr. 75' },
  {
    key: 'zdravstvene_omejitve',
    label: 'Zdravstvene omejitve ali posebnosti',
    placeholder: 'Vpiši, če obstajajo. Sicer pusti prazno.',
    multi: true,
  },
  {
    key: 'kontaktna_oseba',
    label: 'Kontaktna oseba v nujnih primerih',
    placeholder: 'Ime in telefonska številka',
    hint: 'Koga naj pokličemo, če se ti kaj zgodi.',
  },
  {
    key: 'dodatna_vprasanja',
    label: 'Dodatna vprašanja',
    placeholder: 'Morebitna vprašanja za inštruktorja',
    multi: true,
  },
];

export const EMPTY_PROFILE = Object.fromEntries(FIELDS.map((f) => [f.key, '']));

/** Iz zapisa v bazi naredi vrednosti za obrazec. */
export function profileToForm(p) {
  const f = { ...EMPTY_PROFILE };
  FIELDS.forEach((x) => {
    f[x.key] = p?.[x.key] ?? '';
  });
  // Ime in priimek sta v bazi ločena, v obrazcu pa eno polje.
  f.ime = `${p?.ime ?? ''} ${p?.priimek ?? ''}`.trim();
  f.priimek = p?.priimek ?? '';
  f.izjava_sprejeta = p?.izjava_sprejeta ?? false;
  return f;
}

/** Preveri obvezna polja. Vrne { key: sporočilo }. */
export function validateProfile(form, { requireDeclaration = true } = {}) {
  const e = {};
  FIELDS.filter((f) => f.required).forEach((f) => {
    if (!String(form[f.key] ?? '').trim()) e[f.key] = t('To polje je obvezno.');
  });
  if (form.ime?.trim() && !form.ime.trim().includes(' ')) {
    e.ime = t('Vpiši ime in priimek.');
  }
  if (requireDeclaration && !form.izjava_sprejeta) {
    e.izjava = t('Brez potrjene izjave šolanja ne moremo začeti.');
  }
  return e;
}
